import Vue from 'vue';
import Router from 'vue-router';
Vue.use(Router);

let dashboard = {
    path: '/dashboard', name: 'dashboard', redirect: '/dashboard/edit-profile', component: require('@/components/user/dashboard/dashboard-layout/dashboard-layout.vue').default,
    children:
        [
            {
                path: '/dashboard/edit-profile', name: 'Profile', meta: { rule: ['User'] },
                component: require('@/components/user/dashboard/pages/profile/edit-profile/edit-profile.vue').default
            },
            {
                path: '/dashboard/upgrade-membership', name: 'Upgrade Membership', meta: { rule: ['User'] },
                component: require('@/components/user/dashboard/pages/membership/upgrade-membership/upgrade-membership.vue').default
            },
            {
                path: '/dashboard/junior/edit-profile', name: 'Edit Junior Profile', meta: { rule: ['User'] },
                component: require('@/components/user/dashboard/pages/junior/junior-edit-profile/junior-edit-profile.vue').default,
            },
            {
                path: '/dashboard/junior/upgrade-membership', name: 'Junior Membership Upgrade', meta: { rule: ['User'] },
                component: require('@/components/user/dashboard/pages/junior/junior-upgrade-membership/junior-upgrade-membership.vue').default
            },
            {
                path: '/dashboard/basket', name: 'Basket Details', meta: { rule: ['User'] },
                component: require('@/components/user/dashboard/pages/basket/basket-page.vue').default
            },
            {
                path: '/dashboard/adult/join-club', name: 'Join Adult TI Member to your primary club', meta: { rule: ['User'] },
                component: require('@/components/user/dashboard/pages/join-adult-club/join-adult-club.vue').default
            },
            {
                path: '/dashboard/junior/registration', name: 'Register a New Junior Account', meta: { rule: ['User'] },
                component: require('@/components/user/dashboard/pages/junior/junior-registration/junior-registration.vue').default
            },
            {
                path: '/dashboard/races', name: 'Race Registrations History', meta: { rule: ['User'] },
                component: require('@/components/user/dashboard/pages/races/view-race-registrations/view-race-registrations.vue').default
            },
            {
                path: '/dashboard/race-transfer', name: 'Race Transfer', meta: { rule: ['User'] },
                component: require('@/components/user/dashboard/pages/races/transfer-registration/transfer-registration.vue').default
            },
            {
                path: '/dashboard/junior/races', name: 'Junior Race Registrations History', meta: { rule: ['User'] },
                component: require('@/components/user/dashboard/pages/junior/junior-race-registrations/junior-race-registrations.vue').default
            },
            {
                path: '/dashboard/junior/race-transfer', name: 'Junior Race Transfer', meta: { rule: ['User'] },
                component: require('@/components/user/dashboard/pages/junior/junior-race-transfer/junior-race-transfer.vue').default
            },
            {
                path: '/dashboard/membership/card', name: 'Licence Card', meta: { rule: ['User'] },
                component: require('@/components/user/dashboard/pages/membership/membership-card/membership-card.vue').default
            },
            {
                path: '/dashboard/club/management', name: 'Clubs Management', meta: { rule: ['User'] },
                component: require('@/components/user/dashboard/pages/clubs/manage-clubs/manage-clubs.vue').default
            },
            {//this page for access and manage not club admins
                path: '/dashboard/club/management-as-officer', name: 'Clubs Management', meta: { rule: ['User'] },
                component: require('@/components/user/dashboard/pages/clubs/manage-clubs-by-officers/manage-clubs.vue').default
            },
            {
                path: '/dashboard/my-races-new', name: 'Races Management', meta: { rule: ['User'] },
                component: require('@/components/user/dashboard/pages/races/manage-races/manage-races.vue').default
            },
            {
                path: '/dashboard/my-races', name: 'Races Management Old', meta: { rule: ['User'] },
                component: require('@/components/user/dashboard/pages/races/copy-race/copy-race.vue').default
            },
            {
                path: '/dashboard/junior/odm', name: 'One Day Membership for Junior', meta: { rule: ['User'] },
                component: require('@/components/user/dashboard/pages/junior/junior-one-day-membership-menu/junior-one-day-membership-menu.vue').default
            },
            {
                path: '/dashboard/my-race/:id', name: 'Race', meta: { rule: ['User'] },
                component: require('@/components/user/dashboard/pages/races/view-race/layout/layout.vue').default
            },

            {
                path: '/dashboard/club-standard/:id', name: 'Evolve: Club Standards', meta: { rule: ['User'] },
                component: require('@/components/user/dashboard/pages/club-standard/layout/layout.vue').default
            },
            {
                path: '/dashboard/my-races-officer', name: 'Races Where You Are an Officer', meta: { rule: ['User'] },
                component: require('@/components/user/dashboard/pages/races/manage-officer-races/manage-officer-races.vue').default
            },

        ]
};

let course = [
    {
        path: '/courses', name: 'courses', component: require('@/components/user/courses/courses-tabs/courses.vue').default, meta: { rule: ['Any'] }
    },
    {
        path: '/course/:id', name: 'course', component: require('@/components/user/courses/course-details/details-tab/details-tab.vue').default, meta: { rule: ['Any'] }
    },
    {
        path: '/course/subscribe/:id', name: 'course/subscribe', component: require('@/components/user/courses/course-details/subscribe-tab/subscribe-tab.vue').default, meta: { rule: ['User'] }
    },
    {
        path: '/course/thankyou/:id', name: 'course/thankyou', component: require('@/components/user/courses/course-details/thank-you-page/thank-you-page.vue').default, meta: { rule: ['User'] }
    }
];

let admin = [
    {
        path: '/admin/courses', name: 'admin/courses', meta: { rule: ['Admin'] },
        component: require('@/components/admin/courses/courses.vue').default,
    },
    {
        path: '/admin/course/:id', name: 'admin/course', meta: { rule: ['Admin'] },
        component: require('@/components/admin/courses/course-details/course-details.vue').default,
    },
    {
        path: '/admin/payments', name: 'admin/payments', meta: { rule: ['Admin'] },
        component: require('@/components/admin/payments/payments.vue').default
    },
    {
        path: '/admin/club-membership-type', name: 'admin/club-membership-type', meta: { rule: ['Admin'] },
        component: require('@/components/admin/club/club-membership-type/club-membership-type.vue').default
    },
    {
        path: '/admin/members', name: 'admin/members', meta: { rule: ['Admin'] },
        component: require('@/components/admin/members/members-table/members-table.vue').default
    },
    {
        path: '/admin/members-v2', name: 'admin/members-v2', meta: { rule: ['Admin'] },
        component: require('@/components/admin/members/members-table/members-table.vue').default
    },
    {
        path: '/admin/ranking', name: 'admin/ranking', meta: { rule: ['Admin'] },
        component: require('@/components/admin/ranking/ranking-layout/ranking-layout.vue').default
    },
    {
        path: '/admin/races', name: 'admin/races', meta: { rule: ['Admin'] },
        component: require('@/components/admin/races/layout/layout.vue').default
    },
    {
        path: '/admin/club-standards', name: 'admin/club-standards', meta: { rule: ['Admin'] },
        component: require('@/components/admin/club/club-standards/layout/layout.vue').default
    },
    {
        path: '/admin/clubs', name: 'admin/clubs', meta: { rule: ['Admin'] },
        component: require('@/components/admin/club/clubs-list/layout/layout.vue').default
    }
];

let billing = [
    {
        path: '/membership/billing/:id', name: 'membership/billing', meta: { rule: ['User'] },
        component: require('@/components/user/billing-page/billing-page.vue').default,
    },
    {
        path: '/club/billing/:id', name: 'club/billing', meta: { rule: ['User'] },
        component: require('@/components/user/billing-page/billing-page.vue').default
    },
    {
        path: '/course/billing/:id', name: 'course/billing', meta: { rule: ['User'] },
        component: require('@/components/user/billing-page/billing-page.vue').default
    },
    {
        path: '/race-sanctioning/billing/:id', name: 'race/sanctioning/billing', meta: { rule: ['User'] },
        component: require('@/components/user/billing-page/billing-page.vue').default
    },
    {
        path: '/race-entry/billing/:id', name: 'race/entry/billing', meta: { rule: ['User'] },
        component: require('@/components/user/billing-page/billing-page.vue').default
    }
];

var allRoutes = [
    { path: '/', name: 'home', component: require('@/components/HelloWorld.vue').default, meta: { rule: ['Any'] } },
    { path: '/race/entry/quick/:rId/:oId', name: 'Race Quick Entry', component: require('@/components/user/races/quick-entry/quick-entry.vue').default, meta: { rule: ['User'] } },
    { path: '/register', name: 'register', component: require('@/components/user/register/register.vue').default, meta: { rule: ['Any'] } },
    dashboard
];

allRoutes = allRoutes.concat(course);
allRoutes = allRoutes.concat(admin);
allRoutes = allRoutes.concat(billing);
allRoutes.push({ path: '/ranking', name: 'ranking', component: require('@/components/user/ranking/ranking-layout/ranking-layout.vue').default, meta: { rule: ['Any'] } });
allRoutes.push({ path: '/race-calendar', name: 'race-calendar', component: require('@/components/user/race-events/race-calendar/layout/layout.vue').default, meta: { rule: ['Any'] } });
allRoutes.push({ path: '/race-calendar-widget', name: 'race-calendar-widget', component: require('@/components/user/race-events/race-calendar-widget/layout/layout.vue').default, meta: { rule: ['Any'] } });
allRoutes.push({ path: '/race-entry/:rId', name: 'race-entry', component: require('@/components/user/race-events/race-entry/layout/layout.vue').default, meta: { rule: ['Any'] } });
allRoutes.push({ path: '/race-odl', name: 'race-odl', component: require('@/components/user/race-events/race-odl/layout.vue').default, meta: { rule: ['Any'] } });
allRoutes.push({ path: '/clubs', name: 'clubs', component: require('@/components/shared/pages/clubs-widget/clubs-widget.vue').default, meta: { rule: ['Any'] } });
allRoutes.push({ path: '/sage-result', name: 'sage-result', component: require('@/components/user/sage-result/layout.vue').default, meta: { rule: ['Any'] } });



if (process.env.NODE_ENV === 'development') {
    allRoutes.forEach(elem => {
        if (elem && elem.meta && elem.meta.rule && elem.meta.rule.length) {
            elem.meta.rule[0] = 'Any';
        }
    });
}

export default new Router({
    hashbang: false,
    mode: 'history',
    routes: allRoutes
});



// WEBPACK FOOTER //
// ./src/router/index.js